<app-navbar></app-navbar>
<p>The Terms and Condition of the Co-Operative</p>
